__turbopack_context__.v({
  "Copy": "TitleDivider-module-sass-module__0uBHMa__Copy",
  "Title": "TitleDivider-module-sass-module__0uBHMa__Title",
  "TitleDivider": "TitleDivider-module-sass-module__0uBHMa__TitleDivider",
});
